import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { Label, SectionTitle } from "@/components/Reveal";
import { GALLERY, GALLERY_CATS } from "@/data/content";

export default function Gallery() {
  const [cat, setCat] = useState("All");
  const [lightbox, setLightbox] = useState(null);
  const items = cat === "All" ? GALLERY : GALLERY.filter((g) => g.cat === cat);

  return (
    <>
      <section className="pt-40 pb-12 text-center max-w-5xl mx-auto px-5">
        <Label>Portfolio</Label>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5">The Gallery of Extraordinary</h1>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-24">
        <div className="flex flex-wrap justify-center gap-2.5 mb-10">
          {GALLERY_CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`gallery-filter-${c.toLowerCase().replace(/ /g,'-')}`}
              className={`px-4 py-2 text-xs rounded-full border transition-colors duration-300 ${cat === c ? "bg-gold text-midnight border-gold" : "border-gold/30 text-white/75 hover:border-gold"}`}>{c}</button>
          ))}
        </div>
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {items.map((g, i) => (
            <motion.div key={g.img + i} layout initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}
              className="rounded-lg overflow-hidden border border-gold/20 break-inside-avoid cursor-pointer group" onClick={() => setLightbox(g)} data-testid={`gallery-item-${i}`}>
              <div className="relative">
                <img src={g.img} alt={g.cat} className="w-full group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-midnight/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-5"><span className="font-label text-xs text-gold">{g.cat}</span></div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <AnimatePresence>
        {lightbox && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setLightbox(null)}
            className="fixed inset-0 z-[60] bg-midnight/95 backdrop-blur-md flex items-center justify-center p-6" data-testid="gallery-lightbox">
            <button className="absolute top-6 right-6 text-gold" onClick={() => setLightbox(null)} data-testid="lightbox-close"><X size={28} /></button>
            <motion.img initial={{ scale: 0.9 }} animate={{ scale: 1 }} src={lightbox.img} alt={lightbox.cat} className="max-h-[85vh] max-w-full rounded-lg border border-gold/30" />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
